export const getTranslatedAttributeName = (backingField, t) => {
    return t(`attributes:attribute_${toBackingField(backingField)}`);
};

export const getTranslatedAttributeValue = (backingField, value, t) => {
    return t(
        `attributes:attribute_af-${toBackingField(backingField)}_${value}`
    );
};

const toBackingField = backingField => {
    return backingField.toLowerCase().replace('af-', '');
};
